import { Services, joinURLPath } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { globalErrorHandler, macroCacheOptions, projectName, request } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)
const cachedGet = Cache.wrapWithCache(async (key, service, id) => {
  return await request.get(joinURLPath(service, id))
})

export default {
  name: 'Billings',

  props: {
    value: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      loading: false,

      items: []
    }
  },

  computed: {
    ids() {
      return this.value?.meta?.billings?.ids || []
    },
    id() {
      return this.value?.meta?.billing?.id
    }
  },

  mounted() {
    this.get()
  },

  methods: {
    getFormatTableValue(value) {
      if (!value?.data?.priceCalculation) {
        return value
      }

      return {
        ...value,
        data: {
          ...value.data,
          priceCalculation: undefined
        }
      }
    },

    handleError(error) {
      globalErrorHandler(error)
    },

    async getBilling(billingId) {
      const service = Services.billings
      const key = [ projectName, service, 'get', billingId ].filter(Boolean).join(':')

      return await cachedGet(key, service, billingId)
    },

    async get() {
      try {
        this.loading = true

        let requestedIds = [ this.id ]
        if (Array.isArray(this.ids) && this.ids.length) {
          requestedIds = this.ids
        }
        if (requestedIds.length) {
          const results = await Promise.allSettled(requestedIds.map(billingId => {
            return this.getBilling(billingId)
          }))

          this.items = results.reduce((result, settledResult) => {
            switch (settledResult.status) {
              case 'fulfilled': {
                if (settledResult.value) {
                  result.push(settledResult.value)
                }

                break
              }

              default: {
                this.handleError(settledResult.reason)
                break
              }
            }

            return result
          }, [])
        } else {
          this.items = []
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
